module.exports = __webpack_public_path__ + "static/media/done.caa6dead.svg";